import { Chip } from '@mui/material'

const STATUS_CONFIG = {
  queued: { label: 'Queued', color: 'default' },
  parsing: { label: 'Parsing', color: 'info' },
  resolving: { label: 'Resolving', color: 'info' },
  ready_for_review: { label: 'Ready for review', color: 'success' },
  submitted: { label: 'Submitted', color: 'success' },
  failed: { label: 'Failed', color: 'error' },
  cancelled: { label: 'Cancelled', color: 'default' },
}

export default function ImportSessionStatusChip({ status }) {
  const config = STATUS_CONFIG[status] || { label: status, color: 'default' }
  return <Chip label={config.label} color={config.color} size="small" />
}
